<script setup lang="ts">
import AppMobileTopbar from '@/layout/AppMobileTopbar.vue'
</script>

<template>
  <div class="mobile-app layout-wrapper layout-theme-light">
    <app-mobile-topbar/>

    <router-view v-slot="{ Component }">
      <component :is="Component"/>
    </router-view>
  </div>
</template>

<style lang="scss" scoped></style>
